module.exports = __webpack_public_path__ + "img/avatar0.ee03ed6e.png";